<template>
  <v-sheet max-width="1000">
    <v-progress-linear v-if="state === 'loading'"
                       indeterminate
                       color="primary"
    />
    
    <v-card v-else>
      <v-card-title>Sales Margin Settings</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="saveSettings">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="settings.gold"
                label="Gold Sales Margin (%)"
                type="number"
                step="0.01"
                min="0"
                :rules="[v => (v >= 0 && v <= 100) || 'Margin must be a positive percentage']"
                hint="Enter the sales margin percent for Gold"
                persistent-hint
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="settings.silver"
                label="Silver Sales Margin (%)"
                type="number"
                step="0.01"
                min="0"
                :rules="[v => (v >= 0 && v <= 100) || 'Margin must be a positive percentage']"
                hint="Enter the sales margin percent for Silver"
                persistent-hint
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="settings.goldback"
                label="Goldback Sales Margin (%)"
                type="number"
                step="0.01"
                min="0"
                :rules="[v => (v >= 0 && v <= 100) || 'Margin must be a positive percentage']"
                hint="Enter the sales margin percent for Goldbacks"
                persistent-hint
              />
            </v-col>
          </v-row>
          
          <v-btn
            type="submit"
            color="primary"
            :loading="saving"
            :disabled="!isFormValid"
          >
            Save Settings
          </v-btn>
          
          <v-btn
            @click="resetForm"
            class="ml-2"
            :disabled="saving"
          >
            Reset
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>

export default {
  name: "ReportingSettings",
  data() {
    return {
      state: 'loading',
      saving: false,
      settings: {
        gold: '',
        silver: '',
        goldback: ''
      },
      originalSettings: {
        gold: '',
        silver: '',
        goldback: ''
      }
    }
  },
  computed: {
    isFormValid() {
      return this.settings.gold >= 0 && 
             this.settings.silver >= 0 && 
             this.settings.goldback >= 0
    }
  },
  async mounted() {
    await this.loadSettings()
  },
  methods: {
        async loadSettings() {
          try {
            this.state = 'loading'
            
            // Load sales margins setting using generic endpoint
            const response = await this.$axios.get('/admin/application-settings/sales_margins')
            const setting = response.data.setting
            
            if (setting && setting.current_value) {
              this.settings.gold = setting.current_value.gold || ''
              this.settings.silver = setting.current_value.silver || ''
              this.settings.goldback = setting.current_value.goldback || ''
            } else {
              // Use default values if no setting exists
              this.settings.gold = ''
              this.settings.silver = ''
              this.settings.goldback = ''
            }
            
            // Store original values for reset functionality
            this.originalSettings = { ...this.settings }
            
            this.state = 'loaded'
          } catch (error) {
            console.error('Error loading settings:', error)
            this.$root.$emit('toast', {type: 'error', message: 'Error loading settings'});
            this.state = 'error'
          }
        },
    
        async saveSettings() {
          if (!this.isFormValid) return
          
          try {
            this.saving = true
            
            // Prepare margins object
            const margins = {}
            
            if (this.settings.gold !== '') {
              margins.gold = parseFloat(this.settings.gold)
            }
            if (this.settings.silver !== '') {
              margins.silver = parseFloat(this.settings.silver)
            }
            if (this.settings.goldback !== '') {
              margins.goldback = parseFloat(this.settings.goldback)
            }
            
            // Save using generic endpoint
            await this.$axios.put('/admin/application-settings/sales_margins/value', {
              value: margins
            })
            
            this.originalSettings = { ...this.settings }
            this.$root.$emit('toast', {type: 'success', message: 'Settings saved successfully'});
          } catch (error) {
            console.error('Error saving settings:', error)
            if (error.response?.data?.message) {
              this.$root.$emit('toast', {type: 'error', message: `Error: ${error.response.data.message}`});
            } else {
              this.$root.$emit('toast', {type: 'error', message: 'Error saving settings'});
            }
          } finally {
            this.saving = false
          }
        },
    
    resetForm() {
      this.settings = { ...this.originalSettings }
    },
  }
}
</script>

<style scoped>

</style>